module.exports = __webpack_public_path__ + "img/prayer.ea25d843.jpg";